import * as React from "react";
import * as styles from "./early-access.module.css";
// import { graphql } from "gatsby";
import Layout from "../components/Layout";
import SectionWrapper from "../components/SectionWrapper";

// import MailToClipon from "../components/MailToClipon";
import { Seo } from "../components/Seo";

const FeedbackPage = () => {
  let iframeHeight = 1900;
  if (typeof window !== "undefined") {
    var w = window.innerWidth;
    if (w > 550 && w < 640 * 1.2) {
      iframeHeight = 2100;
    }
    if (w < 550) {
      iframeHeight = 2850;
    }
  }
  return (
    <Layout>
      <SectionWrapper
        style={{
          backgroundColor: "var(--main-bg-light)",
          minHeight: "calc(100vh - 96px)",
          paddingTop: "32px",
        }}
      >
        <iframe
          title="Contact us"
          src="https://docs.google.com/forms/d/e/1FAIpQLSeQZv7y6aRTqWnrWRu1chwvGZ8SFBUVOnXwdqoAST0MlNlCsg/viewform?embedded=true"
          className={styles.iframe}
          width="640"
          height={iframeHeight}
          frameborder="0"
          marginheight="0"
          marginwidth="0"
          style={{ width: "100%" }}
        >
          Loading…
        </iframe>
      </SectionWrapper>
    </Layout>
  );
};

export const Head = () => (
  <Seo title="D8ship" index="index, follow">
    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "D8ship",
        url: "https://d8ship.com/",
        logo: "https://d8ship.com/logo.svg",
        sameAs: ["https://www.linkedin.com/company/mabrosi/"],
        email: "mailto:info@mabrosi.com",
      })}
    </script>
  </Seo>
);

export default FeedbackPage;
